import createCrudVuexModule from "@/store/crud";

export const method = createCrudVuexModule({
  namespaced: true,
  path: "/library/transfering-method",
});

export const workspaceTransferingMethod = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/transfering-method",
});

export const managementTransferingMethod = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/transfering-method",
});

// -------------------------------------------

export const prevention = createCrudVuexModule({
  namespaced: true,
  path: "/library/transfering-prevention",
});

export const workspaceTransferingPrevention = createCrudVuexModule({
  namespaced: true,
  path: "/workspace/library/transfering-prevention",
});

export const managementTransferingPrevention = createCrudVuexModule({
  namespaced: true,
  path: "/management/library/transfering-prevention",
});
